export const name = "RAND";
export const summary = `Generates a pseudo-random value of type \`FLOAT64\` in the range of \`[0, 1)\`.`;
export const reference = `
## RAND

Generates a pseudo-random value of type \`FLOAT64\` in the range of \`[0, 1)\`.

\`\`\`
RAND()
\`\`\`

### Description

Generates a pseudo-random value of type \`FLOAT64\` in the range of [0, 1), inclusive of 0 and exclusive of 1.


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
